function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NumberInput from '@rd-web-markets/shared/dist/util/form_fields/NumberInput';
import IsNotSaved from '../IsNotSaved';
import YesOrNoFormField from '@rd-web-markets/shared/dist/util/form_fields/YesOrNoFormField';
import useUpdateState from '../hooks/useUpdateState';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import AffiliateCompaniesSection from './AffiliateCompaniesSection';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const AFFILIATE_FIELDS_ELSTER_V7 = ['is_an_affliated_company_within_the_meaning_of_3_paragraph', 'applied_or_will_for_a_research_allowance', 'max_elig_above_four_million', 'max_eligible_base_to_be_taken_into_account_for_request'];
const AFFILIATE_FIELDS_ELSTER_V8 = ['is_an_affliated_company_within_the_meaning_of_3_paragraph', 'applied_or_will_for_a_research_allowance', 'max_elig_above_four_million', 'max_elig_above_ten_million', 'max_eligible_base_to_be_taken_into_account_for_request'];
const AFFILIATE_BOOLEAN_FIELDS = ['is_an_affliated_company_within_the_meaning_of_3_paragraph', 'applied_or_will_for_a_research_allowance', 'max_elig_above_four_million', 'max_elig_above_ten_million'];
const Affiliates = _ref => {
  let {
    affiliates,
    setAffiliates,
    financialYear,
    elsterId,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setAffiliates, setIsNotSaved);
  const saveData = useErrorHandling(useCallback(async body => {
    if (body.max_eligible_base_to_be_taken_into_account_for_request < 0) {
      throw new Error('Values must be greater than 0');
    }
    const response = await generalRouteSubRouteService.update(body.elster_id, 'elsters', 'affiliate', '', body);
    setAffiliates(_objectSpread({}, response));
    setIsNotSaved(false);
  }, [setAffiliates]));
  const renderInput = (field, index, type) => {
    if (type === 'decimal') {
      return /*#__PURE__*/React.createElement(ChangeHighlighter, {
        as: FormattedNumberInput,
        thousandSeparator: ".",
        decimalSeparator: ",",
        object: field,
        name: 1,
        type: "text",
        size: "sm",
        onlyPositiveNumbers: true,
        onChange: e => updateState({
          target: {
            value: e.target.value
          }
        }, affiliates, field[0]),
        style: {
          width: '100px'
        }
      });
    } else if (type === 'boolean') {
      return /*#__PURE__*/React.createElement("div", {
        key: field[0] + 'affiliateYesOrNo'
      }, /*#__PURE__*/React.createElement(YesOrNoFormField, {
        labelText: t(field[0]),
        formName: 'affiliate' + index,
        dataTestId: field[0],
        checkedField: field[1],
        onChange: updateState,
        onChangeParams: [affiliates, field[0]]
      }));
    }
  };
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const fieldsToRender = isVersion8 ? AFFILIATE_FIELDS_ELSTER_V8 : AFFILIATE_FIELDS_ELSTER_V7;
  const affiliateRows = fieldsToRender.map((key, index) => {
    const value = affiliates[key];
    const isBoolean = AFFILIATE_BOOLEAN_FIELDS.includes(key);
    if (isBoolean) {
      return renderInput([key, value], index, 'boolean');
    }
    return /*#__PURE__*/React.createElement(Row, {
      key: key + 'decimal_row'
    }, /*#__PURE__*/React.createElement(Col, {
      md: 7
    }, /*#__PURE__*/React.createElement("p", null, t(key))), /*#__PURE__*/React.createElement(Col, {
      md: 1
    }, renderInput([key, value], index, 'decimal')));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", null, t('information_on_the_distribution_of_the_maximum_eligible_tax_base_for_associated_enterprises'))), /*#__PURE__*/React.createElement(Col, null)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('financial_year')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, financialYear)), /*#__PURE__*/React.createElement("hr", null), affiliateRows, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(AffiliateCompaniesSection, {
    elsterId: elsterId
  }), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [affiliates]
  }));
};
export default Affiliates;